var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationRightCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278,
    height: 973,
    viewBox: "0 0 278 973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "illustration-right-cut-a",
    d: "M179.2 55.2a21.7 21.7 0 0 0-14-32.7l.1-.5a21.7 21.7 0 0 0-39-13.3 21.8 21.8 0 0 0-34.4 0A21.8 21.8 0 0 0 53 22v.4a21.7 21.7 0 0 0-14 32.8c-1.7-.3-3.4-.4-5.2-.4C17.7 54.8.6 77 .6 77s17 22.3 33.2 22.3c2.7 0 5.2-.3 7.7-.8v43.2a67.6 67.6 0 0 0 135.3 0V98.6c2.4.5 5 .8 7.6.8 16.2 0 33.2-22.3 33.2-22.3s-17-22.3-33.2-22.3c-1.8 0-3.5.1-5.2.4zm-33-6a23.3 23.3 0 0 0 21.2 9c1 4.6 1.7 9.5 1.7 14.4v68.6a60.2 60.2 0 0 1-60 60.3c-33 0-60-27-60-60.3V72.6c0-5 .7-9.8 1.8-14.4l2.7.2c7.5 0 14.2-3.6 18.5-9.2a23.3 23.3 0 0 0 37 0 23.3 23.3 0 0 0 37 0zm57.3 28c0 2.4-18 12.3-23.5 7.7-1.1-.6 1.6-14.6 3.5-15.3 8.6-3.5 20.1 5 20 7.5zM14.1 77c0-2.5 11.4-11 20-7.5 1.9.7 4.6 14.7 3.5 15.2-5.5 4.7-23.4-5.2-23.5-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "illustration-right-cut-b",
    d: "M74 87.1a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "illustration-right-cut-c",
    d: "M152.2 95.5c0 11.4-17 11.4-17 0 0-11.3 17-11.3 17 0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "illustration-right-cut-d",
    width: 12,
    height: 22,
    x: 116,
    y: 145.3,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "illustration-right-cut-e",
    width: 12,
    height: 22,
    x: 91.3,
    y: 145.5,
    rx: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(23 32)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0A303A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M211.7 254.2c23.9 87.6-15 63-32.6 142s108.3 249.5 44.2 307c-64 57.5-177.9 86.5-196.8 94.8C7.7 806.4 0 882.3 0 885.8c0 3.4 107.6 18.6 73.5-46.3-34.1-65 208.3-37.3 208.3-140.3 0-102.9-27.7-397.7 76.4-363.3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-21 242.8 -119.9)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#020D26",
    xlinkHref: "#illustration-right-cut-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A303A",
    xlinkHref: "#illustration-right-cut-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#020D26",
    xlinkHref: "#illustration-right-cut-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A303A",
    xlinkHref: "#illustration-right-cut-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#020D26",
    xlinkHref: "#illustration-right-cut-c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A303A",
    xlinkHref: "#illustration-right-cut-c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#020D26",
    xlinkHref: "#illustration-right-cut-d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A303A",
    xlinkHref: "#illustration-right-cut-d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#020D26",
    xlinkHref: "#illustration-right-cut-e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A303A",
    xlinkHref: "#illustration-right-cut-e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationRightCut);
export default __webpack_public_path__ + "static/media/illustration-right-cut.06ac517e82bc358e79358cad5183aa45.svg";
export { ForwardRef as ReactComponent };